import { connect } from "react-redux";
import { type RootState } from "../../../Application/globaltypes/redux";
import { DetailsSubHeader } from "../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";

export type EditPackSubheaderContainerProps = DetailsSubHeaderProps & {
  showLastModified: boolean;
};

const mapStateToProps = (state: RootState, ownProps: EditPackSubheaderContainerProps) => ({
  isUpdateInProgress: state.packs.packEntityStateReducer.isEntityCommandInProgress && ownProps.isUpdateInProgress,
  lastModifiedDateTime: ownProps.showLastModified
    ? state.packs.packEntityStateReducer.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
    : undefined,
});

export default connect(mapStateToProps)(DetailsSubHeader);
